<template>
<div class="app">
	<div class='title'><span style="font-weight:900;"> 极速订 </span>  | <span style="font-weight:300;"> 卖家后台</span></div>
	<div class="login">
		<main class="login-main">
			<div class="login-part">
				<div class="login-container">
					<slot></slot>
			</div>
			</div>
			<img src="~images/img/login.jpg" alt="">
		</main>
	</div>
</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
	name: 'lgoin',
	computed: {
		...mapState({
			platFormName: state => state.platFormStore.platFormName
		})
	}
}
</script>
<style lang="stylus" scoped>
.app{
	display: flex;
	flex-direction :column;
	width :100%;
	height :100%;
	.title{
		height:60px;
		min-height:60px;
		width:calc(100% - 20px);
		background-color :#ffffff;
		text-align :left;
		line-height 60px;
		font-size:22px;
		padding-left:20px
	}
	.login {
		background-image url('~images/img/login-bg.jpg')
		background-repeat: no-repeat
		background-position: center
		background-size: cover
		display flex
		flex: 1
		justify-content center
		align-items  center
		.login-main {
			margin-top:20px
			margin-bottom :20px
			width: 800px
			height: 500px
			border-radius 8px
			.login-part {
				width: 50%
				height: 100%
				float left
		border-radius 8px 0 0 8px
		background: rgba(255, 255, 255, 0.8)
			}
			img {
				width: 50%
				height: 100%
				float right
			}
		}
	}
}

</style>
